// extracted by mini-css-extract-plugin
export default {"root":"EK16d","large":"_1x5J7","hoverable":"_1Ea_7","medium":"_1Zqam","small":"_3GoTZ"};